import * as React from 'react';
import {useEffect, useState} from 'react';
import {refreshToken, getToken, redirectCallback} from './authRequesterUtils';
import {AuthProviderProps} from "./types";
import {getExpiryTimeAsString} from "./tokenUtils";


const AuthContext = React.createContext("");

export const AuthProvider = ({
  homePageUrl = "/",
  loggedOutUrl,
  loadingScreen,
  children,
  authUrl,
  redirectUrl,
  clientId,
  refreshTokensEnabled,
  scope
}: AuthProviderProps): JSX.Element => {
  const [token, setToken] = useState<string>(sessionStorage.getItem('token') || "");
  const params = (new URL(document.location as unknown as string)).searchParams;

  const code = params.get('code');

  useEffect(() => {
    if (!token && window.location.pathname !== '/health') {

      if (code) {
        getToken(code, authUrl, redirectUrl, clientId)
          .then((result) => {

            const accessToken = result.access_token;
            const idToken = result.id_token;

            window.history.replaceState({}, "", '/');

            sessionStorage.setItem('token', accessToken);
            sessionStorage.setItem('id_token', idToken);
            sessionStorage.setItem('logged_out_url', loggedOutUrl);

            setToken(accessToken);

            if(refreshTokensEnabled) {
              sessionStorage.setItem('refresh_token',  result.refresh_token as string);
              sessionStorage.setItem('expiry', getExpiryTimeAsString(result.expires_in));
            }

            window.location.assign(sessionStorage.getItem('original_location') || homePageUrl);

            sessionStorage.removeItem('original_location')
          })
          .catch((error) => {
            window.location.assign(`${loggedOutUrl}?error_message=${error.message}`)
          });
      } else {
        return redirectCallback(redirectUrl, clientId, authUrl, scope);
      }
    }
  }, [token]);

  // if(refreshTokensEnabled) {
  //   refreshToken( authUrl, redirectUrl, clientId);
  // }
  if (!token) return loadingScreen;

  return <AuthContext.Provider value={token}>{children}</AuthContext.Provider>;
};